import React, {useEffect, useState} from "react";
import {getReport} from "../../../services/Trading";
import {useTranslation} from "react-i18next";
import {FaClipboardList} from "react-icons/fa";
import {
    InsightStack,
    InsightRow,
    InsightIconBox,
    InsightText,
    InsightTitle,
    InsightDesc,
    InsightValue,
    getAccent,
} from "../TradingInsightCard/styles";

export default function CardTotalOperations({filter}) {
    const [qtdeWin, setQtdeWin] = useState(null);
    const [qtdeLoss, setQtdeLoss] = useState(null);
    const [qtdeDraw, setQtdeDraw] = useState(null);
    const { t } = useTranslation();

    useEffect(() => {
        getReport({
            startDate: filter[0].startDate,
            endDate: filter[0].endDate,
            orderBy: 'profitObtained',
            order: 'DESC'
        }).then((data) => {
            if (!data || data === '' || !data.data) {
                return;
            }

            setQtdeWin(data.data.win.qtde);
            setQtdeLoss(data.data.loss.qtde);
            setQtdeDraw(data.data.draw.qtde);
        });
    }, [filter]);

    const a = getAccent('resumeNeutral');
    const total =
        qtdeWin != null && qtdeLoss != null && qtdeDraw != null
            ? (qtdeLoss || 0) + (qtdeWin || 0) + (qtdeDraw || 0)
            : null;

    return (
        <InsightStack>
            <InsightRow $variant="resumeNeutral">
                <InsightIconBox $variant="resumeNeutral">
                    <FaClipboardList aria-hidden/>
                </InsightIconBox>
                <InsightText>
                    <InsightTitle>{t('traging_report_card_resume_total')}</InsightTitle>
                    <InsightDesc>{t('trading_report_desc_resume_total')}</InsightDesc>
                </InsightText>
                <InsightValue $color={a.value}>
                    {total != null ? total : '—'}
                </InsightValue>
            </InsightRow>
        </InsightStack>
    );
}
